import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/andover-mn")({
  beforeLoad: () => {
    throw redirect({
      to: "/service-areas/$slug",
      params: { slug: "andover" },
      statusCode: 301,
    });
  },
});
